/* eslint-disable react/no-unused-state */
import Required from "components/Required/required.component";
import { ALERTAS_PERMISSIONS } from "constants/index";
import dompurify from "dompurify";
import { ErrorMessage } from "formik";
import React, { Component, Fragment } from "react";
import ReactQuill from "react-quill";
import { connect } from "react-redux";
import "react-toastify/dist/ReactToastify.css";
import { validatePermission } from "utils/permissionHelper";
import InputText from "../../../components/Input/inputText.component";
import WidgetModalForm, {
	ModalFormContext
} from "../../../components/Modal/modalForm.component";
import Title from "../../../components/Title/title.component";
import AlertaService from "../../../services/alertaService";
import ToastHelper from "../../../utils/toastHelper";
import ListagemContainer from "../../comum/containers/listagem.container";
import FiltroAvancado from "./pesquisaAvancadaAlertas";

const mapStateToProps = state => ({ usuario: state.auth.usuario });

class ListaExpectativaAlerta extends Component {
	constructor(props) {
		super(props);
		this.child = React.createRef();
		this.state = {
			pesquisaAvancada: false,
			filtro: {
				simplificado: true,
				ordem: ""
			},
			itemSelecionado: {
				...{},
				mensagem: "",
				justificativaStatus: "",
				tipoStatusAlerta: ""
			},
			search: "",
			isOpenCessar: false,
			isOpenExcluir: false,
			pesquisaAnterior: "",
			key: 0,
			orderIcon: {
				nome: "",
				icon: undefined
			},
			inititalOrderIcon: {
				colunaTable: "id",
				iconOrderDirection: "fas fa-arrow-down"
			},
			mensagemHandled: false
		};
	}

	columns = [
		{
			id: 0,
			title: "Identificador",
			property: "id",
			order: "id"
		},
		{
			id: 1,
			title: "Origem da informação",
			property: "dadoParametrizado.iniciador.nome",
			order: "dadoParametrizado.iniciador.nome"
		},
		{
			id: 5,
			title: "Categoria do evento",
			property: "dadoParametrizado.categoriaEvento.nome",
			order: "dadoParametrizado.categoria.nome"
		},
		{
			id: 2,
			title: "Data da emissão",
			property: "dataHoraEmissao",
			order: "dataHoraEmissao"
		},
		{
			id: 3,
			title: "Status",
			property: "status.nome",
			order: "status.nome"
		}
	];

	actions = [
		{
			id: 0,
			name: "Visualizar",
			icon: "fas fa-search",
			action: item => this.handleVisualizar(item),
			enabled: item => item.id
		},
		{
			id: 1,
			name: "Cessar",
			icon: "fas fa-redo",
			action: item => this.handleOpenModalCessar(item),
			enabled: item =>
				this.enableMenu(item, "ALERTA_ATIVO", [
					ALERTAS_PERMISSIONS.GERENCIAR
				])
		},
		{
			id: 2,
			name: "Evoluir",
			icon: "fas fa-edit",
			action: item => this.handleEvoluir(item),
			enabled: item =>
				this.enableMenu(item, "EM_ANDAMENTO", [
					ALERTAS_PERMISSIONS.GERENCIAR
				])
		},
		{
			id: 3,
			name: "Cancelar alerta",
			icon: "far fa-times-circle fa-md",
			action: item => this.handleOpenModalExcluir(item),
			enabled: item =>
				this.enableMenu(item, "EM_ANDAMENTO", [
					ALERTAS_PERMISSIONS.GERENCIAR
				])
		}
	];

	enableMenu(item, status, permission) {
		const { usuario } = this.props;

		if (!usuario.sub) return false;

		const hasPermission = validatePermission(permission, usuario.soeAcoes);

		if (!hasPermission) return false;

		return (
			item.status &&
			item.status.statusAlerta === status &&
			item.status.statusAlerta !== "ALERTA_FINALIZADO"
		);
	}

	/* Filtro */
	handlePesquisaSimplificada = () => {
		const prevState = this.state;
		prevState.filtro.simplificado = true;
		prevState.pesquisaAvancada = false;
		prevState.orderIcon = { icon: undefined, nomeColuna: "" };
		this.setState(prevState);
		this.child.current.limpaCampoPesquisaSimplificada();
	};

	ordenar = ordem => {
		const direcaoOrdemFiltro = this.child.current.handleSearchByOrder(
			ordem,
			true
		);

		if (direcaoOrdemFiltro === "DESC") {
			this.setState({
				orderIcon: { icon: "fas fa-arrow-down", nomeColuna: ordem }
			});
		} else {
			this.setState({
				orderIcon: { icon: "fas fa-arrow-up", nomeColuna: ordem }
			});
		}
	};

	handlePesquisaAvancada = () => {
		const prevState = this.state;
		prevState.filtro.simplificado = false;
		prevState.pesquisaAvancada = true;
		prevState.orderIcon = { icon: undefined, nomeColuna: "" };
		this.setState(prevState);
	};

	resetIconOrder = () => {
		this.setState({ orderIcon: { icon: undefined, nomeColuna: "" } });
	};

	handleOpenModalCessar = item => {
		this.setState({
			itemSelecionado: {
				...item,
				mensagem: "",
				tipoStatusAlerta: "CESSADO"
			}
		});

		this.setState({
			isOpenCessar: true,
			mensagemCessarIsValid: false
		});
	};

	handleOpenModalExcluir = item => {
		this.setState({
			itemSelecionado: {
				...item,
				justificativaStatus: "",
				tipoStatusAlerta: "CANCELADO"
			}
		});

		this.setState({ isOpenExcluir: true });
	};

	handleCadastrarAlerta = () => {
		const { history } = this.props;

		AlertaService.createAlerta({
			id: 0,
			tipoStatusAlerta: "EM_ANDAMENTO"
		}).then(item => {
			history.push(`/alerta/dados/${item.data.id}`);
		});
	};

	handleEvoluir = item => {
		const { history } = this.props;
		history.push(`/alerta/dados/${item.id}`);
	};

	handleVisualizar = item => {
		const { history } = this.props;
		history.push(`/visualizarAlerta/dados/${item.id}`);
	};

	handleCessar = values => {
		this.setState({ mensagemHandled: true });
		const {
			state: { key: stateKey, mensagemCessarIsValid }
		} = this;
		if (mensagemCessarIsValid) {
			AlertaService.alterarStatusAlerta({
				id: values.id,
				tipoStatusAlerta: values.tipoStatusAlerta,
				mensagem: values.mensagem
			}).then(() => {
				this.setState({
					mensagem: "",
					isOpenCessar: false,
					itemSelecionado: {
						...{},
						tipoStatusAlerta: ""
					}
				});
				AlertaService.findAll({ pagina: 0 }).then(() =>
					this.setState({ key: stateKey + 1 })
				);
				ToastHelper.success("Alerta cessado!");
			});
		}
	};

	handleExcluir = values => {
		const {
			state: { key: stateKey }
		} = this;
		AlertaService.alterarStatusAlerta({
			id: values.id,
			tipoStatusAlerta: values.tipoStatusAlerta,
			justificativaStatus: values.justificativaStatus
		}).then(() => {
			this.setState({
				isOpenExcluir: false,
				itemSelecionado: {
					...{},
					justificativaStatus: "",
					tipoStatusAlerta: ""
				}
			});
			AlertaService.findAll({ pagina: 0 }).then(() =>
				this.setState({ key: stateKey + 1 })
			);
			ToastHelper.success("Alerta cancelado!");
		});
	};

	handleCloseCessar = () => {
		this.setState({
			isOpenCessar: false,
			mensagem: ""
		});
	};

	innerHTMLPurified = text => {
		const textToBeSanitizer = text;
		const sanitizer = dompurify.sanitize;

		// eslint-disable-next-line react/no-danger
		return (
			<div
				dangerouslySetInnerHTML={{
					__html: sanitizer(textToBeSanitizer) || " "
				}}
			/>
		);
	};

	createModelCessar = (
		item,
		{ isOpenCessar, mensagem, mensagemCessarIsValid } = this.state
	) => (
		<WidgetModalForm
			textCancelar="Cancelar"
			textConfirmar="Reemitir"
			title="Cessar alerta"
			confirmar={this.handleCessar}
			isOpen={isOpenCessar}
			initialValues={item}
			cancelar={this.handleCloseCessar}
			modalConfirmarFechar
			modalConfirmarCancelar
			modalConfirmarCancelarTitulo="Atenção!"
			modalConfirmarCancelarCorpo="Tem certeza que deseja cancelar? Todos os dados preenchidos serão perdidos."
			iconCancelar="fas fa-times"
			iconConfirmar="fas fa-paper-plane"
		>
			<ModalFormContext.Consumer>
				{({ values, setFieldValue }) => (
					<div className="row">
						<div className="col-md-12">
							<p>
								<strong>Identificador:</strong> {item.id}
							</p>
							<p>
								<strong>Mensagem:</strong>{" "}
								{this.innerHTMLPurified(
									((item || {}).emissaoAlerta || {}).mensagem
								) || "-"}
							</p>
							<hr />
							<div className="form-group">
								<label>
									<strong>Nova mensagem:</strong> <Required />
								</label>
								<ReactQuill
									name="mensagem"
									onChange={(html, delta, source, editor) => {
										const isVazio = editor.getText().trim();
										console.log(isVazio);
										if (isVazio !== "") {
											this.setState({
												mensagemCessarIsValid: true
											});
										} else {
											this.setState({
												mensagemCessarIsValid: false
											});
										}
										setFieldValue("mensagem", html);
									}}
									dafaultValue={values.mensagem}
									style={{
										overflowY: "scroll",
										maxHeight: "18.2em"
									}}
								/>
								{!mensagemCessarIsValid &&
									this.state.mensagemHandled && (
										<ErrorMessage
											render={() => (
												<span className="text-danger">
													Campo obrigatório para
													cessar alerta
												</span>
											)}
										/>
									)}
							</div>
						</div>
					</div>
				)}
			</ModalFormContext.Consumer>
		</WidgetModalForm>
	);

	createModelExcluir = (
		item,
		{ isOpenExcluir: isOpenValue } = this.state
	) => (
		<WidgetModalForm
			textCancelar="Fechar"
			textConfirmar="Confirmar"
			title="Cancelar possível alerta"
			confirmar={this.handleExcluir}
			isOpen={isOpenValue}
			initialValues={item}
			cancelar={() => this.setState({ isOpenExcluir: false })}
			modalConfirmarFechar
			modalConfirmarCancelar
			modalConfirmarCancelarTitulo="Atenção!"
			modalConfirmarCancelarCorpo="Tem certeza que deseja fechar? Todos os dados preenchidos serão perdidos."
			iconCancelar="fas fa-times"
			iconConfirmar="fas fa-check"
		>
			<ModalFormContext.Consumer>
				{({ values, handleChange }) => (
					<div className="row">
						<div className="col-md-12">
							<p>
								<strong>Origem da informação: </strong>

								<label>
									{item.dadoParametrizado &&
									item.dadoParametrizado.iniciador
										? item.dadoParametrizado.iniciador.nome
										: "-"}
								</label>
							</p>

							<p>
								<strong> Data da informação: </strong>
								<label>
									{item.dadoParametrizado &&
									item.dadoParametrizado
										.dataOcorrenciaFormatada
										? item.dadoParametrizado
												.dataOcorrenciaFormatada
										: "-"}
								</label>
							</p>

							<p>
								<strong>
									Informações recebidas da origem:{" "}
								</strong>
								<label>
									{item.dadoParametrizado &&
									item.dadoParametrizado.informacoes
										? item.dadoParametrizado.informacoes
										: "-"}
								</label>
							</p>

							<hr />
							<div className="form-group">
								<strong>Justificativa:</strong>
								<InputText
									name="justificativaStatus"
									type="textarea"
									maxLength="255"
									className="form-control form-control-sm"
									value={values.justificativaStatus || ""}
									onChange={handleChange}
								/>
							</div>
						</div>
					</div>
				)}
			</ModalFormContext.Consumer>
		</WidgetModalForm>
	);

	/*
		Formata data no padrão dd-mm-yyyy hh:mm
	*/
	formataDataParaExportacao = () => {
		let formataData = new Date();

		const dia = String(formataData.getDate()).padStart(2, "0");
		const mes = String(formataData.getMonth() + 1).padStart(2, "0");
		const ano = formataData.getFullYear();

		const hora = String(formataData.getHours()).padStart(2, "0");
		const minuto = String(formataData.getMinutes()).padStart(2, "0");
		formataData = `${dia}-${mes}-${ano} ${hora}-${minuto}`;

		return formataData;
	};

	handleReload() {
		this.child.current.initialize();
	}

	pesquisaAvancada(child) {
		const {
			state: { pesquisaAvancada, filtro }
		} = this;
		return (
			pesquisaAvancada && (
				<FiltroAvancado
					filtro={filtro}
					handlePesquisaSimplificada={this.handlePesquisaSimplificada}
					serviceSearch={values => {
						this.setState({ pesquisaAvancada: { ...values } });
						child.current.manualSearch(
							AlertaService.findAll,
							values
						);
					}}
					resetIconOrder={this.resetIconOrder}
				/>
			)
		);
	}

	render() {
		const {
			state: {
				key,
				pesquisaAvancada,
				itemSelecionado,
				orderIcon,
				inititalOrderIcon
			}
		} = this;
		return (
			<Fragment>
				<div className="row">
					<div className="col-md-12">
						<Title>Expectativa de alertas</Title>
					</div>
				</div>
				<ListagemContainer
					key={key}
					ref={this.child}
					columns={this.columns}
					actions={this.actions}
					listaTitle="Listagem de alertas"
					pesquisaTitle={null}
					servicePaginacao={AlertaService.findAll}
					serviceSearch={AlertaService.findAll}
					handleCadatroPage={this.handleCadastrarAlerta}
					titleButtonCadastrar="Novo alerta"
					titleButtonExportar="Exportar CSV"
					emptyMessage="Não há itens cadastrados."
					ComponenteCadastrar={null}
					toastMessage="Alerta cadastrada com sucesso"
					searchPlaceHolder="Pesquise por categoria do evento"
					pesquisaAvancada={pesquisaAvancada}
					isPesquisaAvancada
					handlePesquisaAvancada={this.handlePesquisaAvancada}
					ordenar={this.ordenar}
					isOrderByGrid
					orderIcon={orderIcon}
					inititalOrderIcon={inititalOrderIcon}
					permission={ALERTAS_PERMISSIONS.VISUALIZAR}
					permissionCadastrar={ALERTAS_PERMISSIONS.GERENCIAR}
				>
					{this.pesquisaAvancada(this.child)}
				</ListagemContainer>

				{this.createModelCessar(itemSelecionado)}
				{this.createModelExcluir(itemSelecionado)}
			</Fragment>
		);
	}
}

export default connect(mapStateToProps)(ListaExpectativaAlerta);
